import React, { useCallback, useEffect, useId, useRef, useState, useMemo } from 'react';
import classNames from '../helpers/classNames.js';
const DropDownSearchable = ({
  id,
  label,
  inputId = null,
  inputName = null,
  inputValue = '',
  inputDefaultValue = null,
  onChange = () => {},
  disabled = false,
  options,
  placeholder = '',
  withBottomGap = false,
  rawInputProps = {}
}) => {
  const componentId = useId();
  const componentRef = useRef();
  const className = useMemo(() => classNames('ebds-drop-down-searchable', {
    '--disabled': disabled,
    '--with-bottom-gap': withBottomGap
  }), [disabled, withBottomGap]);
  const customId = id || `ebds-drop-down-searchable__list-${componentId}`;
  const inputCustomId = inputId || `ebds-drop-down-searchable__input-${componentId}`;
  const inputCustomName = inputName || 'ebds-drop-down-searchable__input';
  const inputInitialValue = inputDefaultValue || inputValue;
  const [selectedOption, setSelectedOption] = useState(inputInitialValue);
  const handleChange = useCallback(({
    target
  }) => {
    setSelectedOption(target.value);
    const selectedId = options.find(el => el.name === target.value)?.id;
    onChange(target.value, target.name, selectedId);
  }, [onChange, options]);
  useEffect(() => {
    if (!inputInitialValue) {
      return;
    }
    setSelectedOption(inputInitialValue);
  }, [inputInitialValue]);
  if (!options || !options.length) {
    throw new Error('DropDownSearchable: options property is required and must be an array with at least one element.');
  }
  return /*#__PURE__*/React.createElement("div", {
    id: `ebds-drop-down-searchable-${componentId}`,
    ref: componentRef,
    className: className
  }, label ? /*#__PURE__*/React.createElement("label", {
    htmlFor: inputCustomId
  }, label) : null, /*#__PURE__*/React.createElement("input", Object.assign({
    list: customId,
    id: inputCustomId,
    name: inputCustomName,
    placeholder: placeholder || '',
    className: "ebds-drop-down-searchable__input",
    onChange: handleChange,
    disabled: disabled,
    value: selectedOption,
    autoComplete: "off",
    type: "text"
  }, rawInputProps)), /*#__PURE__*/React.createElement("datalist", {
    id: customId
  }, options.map(option =>
  /*#__PURE__*/
  // eslint-disable-next-line jsx-a11y/control-has-associated-label
  React.createElement("option", {
    key: option?.id,
    value: option?.name,
    disabled: option?.disabled,
    "data-value": option?.id
  }))));
};
export default DropDownSearchable;